import { Fragment, useRef, useState } from "react";
import { useAppSelector } from '../../redux/hooks';
import { Container, Dropdown, Nav, Navbar, Offcanvas, Stack } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Paths } from "../routes/Routes";
import { useAppDispatch } from "../../redux/hooks";
import { clearToken, getAppId } from "../../redux/tokenSlice";
import { clearAppState } from "../../redux/appStateSlice";
import SignOutModal from "./SignOutModal";
import { ApolloConsumer } from '@apollo/client';
import { Logout } from '../../graphQL/api';
import { replace } from 'lodash';
import { clearBackNavigation, clearSelectedGroup } from "../../redux/navigationSlice";

const NavigationBar = ({title, isHome}) => {
	const [showSideMenu, setShowSideMenu] = useState(false);
	const [showSignOutModal, setShowSignOutModal] = useState(false)
	const currentUser = useAppSelector(state => state.appState.currentUser);
	const currentSelectedGroup = useAppSelector(state => state.nav.currentSelectedGroup)
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const bondedPairToken = useAppSelector(state => state.token.bondedPairToken)
	const backNavigation = useAppSelector(state => state.nav.backNavigation)

	const apolloClient = useRef<any>()

	function toggleSidMenu() {
		setShowSideMenu(!showSideMenu)
	}

	function navigateToHome(e) {
		e.preventDefault();
		navigate(Paths.HOME)
		dispatch(clearBackNavigation())
	}

	function navigateBack(e) {
		e.preventDefault();
		navigate(backNavigation)
		dispatch(clearBackNavigation())
	}

	function navigateToMissedAcknowledgments(e) {
		e.preventDefault();

		const path = replace(Paths.MANAGER_MISSED_ACKNOWLEDGMENTS, ':groupid', currentSelectedGroup?.groupID);
		navigate(path);
	}

	function promptForSignOut(e, client) {
		e.preventDefault();

		apolloClient.current = client

		setShowSideMenu(false)
		setShowSignOutModal(true)
	}

	function signOutClicked() {
		setShowSignOutModal(false)

		setShowSideMenu(false); 
		navigate(Paths.LOGIN);

		if (bondedPairToken) {
			Logout(bondedPairToken, getAppId(), response => {})
		}
		
		dispatch(clearToken());
		dispatch(clearAppState())
		dispatch(clearBackNavigation())
		dispatch(clearSelectedGroup())

		if (apolloClient.current) {
			apolloClient.current.clearStore()
		}
	}

	function renderDivider() {
		return <Dropdown.Divider style={{opacity:0.6, marginLeft:-13, marginRight:-13}}/>
	}

	return (
		<Navbar collapseOnSelect key={'asdas'} className="navbar-toggler" expand={false} sticky="top" style={{backgroundColor:'#212121', marginLeft: -10, height:50, position:'fixed', top:0, width:'100%', zIndex:100}} variant="dark">
			<Container fluid>
				<Stack direction="horizontal" >
					{ isHome ?
						<button className="navbar-toggler" type="button" data-mdb-toggle="collapse" onClick={ e =>toggleSidMenu() } 
							data-mdb-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
							aria-expanded="false" aria-label="Toggle navigation" style={{border: "none !important"}}> <i className="fas fa-bars"></i>
						</button>
						:
						<button className="navbar-toggler" type="button" data-mdb-toggle="collapse" onClick={ e => navigateBack(e) }
							data-mdb-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
							aria-expanded="false" aria-label="back navigation" style={{border: "none !important"}}> <i className="fas fa-chevron-left"></i>
						</button>
					}
					
					<span style={{color:'white'}}>{title ? title : ""}</span> 
				</Stack>

				<Navbar.Offcanvas
					id={`offcanvasNavbar-expand-123aas`}
					aria-labelledby={`offcanvasNavbarLabel-expand-25233`}
					placement="top"
					style={{color:'white'}}
					show={showSideMenu}
				>
					<Offcanvas.Header >
						<Offcanvas.Title id={`offcanvasNavbarLabel-expand-65623432`}>
							Menu
						</Offcanvas.Title>
						<i onClick={ e => setShowSideMenu(false)} className="fa-solid fa-xmark"/>
					</Offcanvas.Header>
					<Offcanvas.Body>
						{ renderDivider() }
						<Nav className="justify-content-end flex-grow-1 pe-3">
							<Nav.Link style={{color:'white'}} onClick={ e => { setShowSideMenu(false); navigateToHome(e)} }>Home</Nav.Link>
						</Nav>
						{ renderDivider() }
						{ currentUser && !currentUser.isInDriverRole &&
							<Fragment>
								<Nav className="justify-content-end flex-grow-1 pe-3">
									<Nav.Link style={{color:'white'}} onClick={ e => { setShowSideMenu(false); navigateToMissedAcknowledgments(e)} }>Missed Acknowledgments</Nav.Link>
								</Nav>
								{ renderDivider() }
							</Fragment>
						}
						<Nav className="justify-content-end flex-grow-1 pe-3">
							<ApolloConsumer>
								{ client =>
									<Nav.Link style={{color:'white'}} onClick={ e => promptForSignOut(e, client) }>Sign Out</Nav.Link>
								}
							</ApolloConsumer>
							
						</Nav>
					</Offcanvas.Body>
				</Navbar.Offcanvas>
				{ showSignOutModal && <SignOutModal shouldShow={showSignOutModal} onSignOut={()=>signOutClicked()} onClose={()=>setShowSignOutModal(false) } />}
			</Container>
		</Navbar>
	)
}

export default NavigationBar;